// extracted by mini-css-extract-plugin
export default {"MainContainer":"AboutWorkspace_MainContainer__1kFp3","InviteButton":"AboutWorkspace_InviteButton__GbAMZ","Modal":"AboutWorkspace_Modal__rbzEM","Input":"AboutWorkspace_Input__gyHRW"};